<div class="dialog-wrapper">
    <div *ngIf="!SHOW_DOC_WITHOUT_TITLE.includes(claim.name) && currentPolicyApp"
         mat-dialog-title
         class="dialog-title"
    >
        {{currentPolicyApp ? ('Privacy Policy for ' + currentPolicyApp?.name) : claim?.title}}
    </div>
    <div mat-dialog-content>
        <ng-container *ngIf="!isGettingCurrentApp; else gettingCurrentAppSpinner">
            <ngc-ann-content-viewer [format]="claim?.internalFormat" [documentUrl]="documentUrl"
                                    [applicationName]="currentPolicyApp?.name"></ngc-ann-content-viewer>

            <div style="margin-bottom: 15px;"><strong>This document was last modified
                on {{claim?.regDate | datePlusGMTPipe: 'medium'}}</strong></div>

            <mat-checkbox *ngIf="isNeedConfirm(claim) && !displayOnly" [(ngModel)]="alreadyAccepted">
                <span
                    class="mat-caption">I agree {{currentPolicyApp ? ('Privacy Policy for ' + currentPolicyApp?.name) : docTitle}}</span>
            </mat-checkbox>
        </ng-container>

        <ng-template #gettingCurrentAppSpinner>
            <div class="spinner-block">
                <mat-progress-spinner
                    [color]="'accent'"
                    [diameter]="50"
                    [mode]="'indeterminate'">
                </mat-progress-spinner>
            </div>
        </ng-template>
    </div>

    <mat-dialog-actions *ngIf="claim">
        <div *ngIf="isNeedConfirm(claim) && !displayOnly"
             class="button-row"
             [ngClass]="{'authentication-actions': (eventName == 'Authentication')}"
        >
            <span>{{currentIndex}} of {{total}} documents</span>

            <div>
                <button *ngIf="acceptOnly" mat-button class="discard-btn" (click)="result()">Cancel</button>
                <button *ngIf="!acceptOnly" mat-button class="discard-btn" (click)="result('reject')">Reject</button>
                <button mat-raised-button color="primary" class="confirm-btn" [disabled]="!alreadyAccepted" (click)="result('accept')">Accept</button>
            </div>
        </div>
        <div *ngIf="!isNeedConfirm(claim) || displayOnly" class="button-row" fxLayoutAlign="flex-end center">
            <button mat-raised-button color="primary" class="discard-btn" (click)="result()">Close</button>
        </div>
    </mat-dialog-actions>
</div>
